import React from 'react';
import PropTypes from 'prop-types';
import styles from './Title.module.less';
import clsx from 'clsx';

const Title = ({ children, withinGrid = false }) => {
  return (
    <div
      className={clsx('font-primary-bold', styles.title, {
        [styles.grid]: withinGrid,
      })}
    >
      <span>{children}</span>
    </div>
  );
};
Title.displayName = 'Title';
Title.propTypes = {
  children: PropTypes.node,
  withinGrid: PropTypes.bool,
};

export default Title;
